module.exports = __webpack_public_path__ + "img/Img28b_204582_CeEt-541-6K14-681.169e3729.jpg";